import React from "react";
import { MenuTab } from "../../utils/enum";
import { useState } from "react";
import {
    ButtonGroup,
    Grid,
    Button,
    Menu,
  } from "@mui/material";
  import { styled } from "@mui/material/styles";


  const StyledDiv = styled("div")(({ theme }) => ({
    "& .selectedMenu": {
      backgroundColor: "#05234A",
      color: "white",
      "&:hover": {
        backgroundColor: "#05234A",
      },
    },
  }));
function Menus({selectedMenu,handleState}) {
  return (
    <Grid item>
      <ButtonGroup color="primary" aria-label="outlined primary button group">
        <Button
          style={{
            borderBottomLeftRadius: "10px",
            borderTopLeftRadius: "10px",
          }}
          className={selectedMenu === "all" ? "selectedMenu" : ""}
          onClick={() => handleState("all")}
        >
          {MenuTab.ALL}
        </Button>
        <Button
          className={selectedMenu === "published" ? "selectedMenu" : ""}
          onClick={() => handleState("published")}
        >
          {MenuTab.PUBLISHED}
        </Button>
        <Button
          className={selectedMenu === "pen_publish" ? "selectedMenu" : ""}
          onClick={() => handleState("pen_publish")}
        >
          {MenuTab.PENDING_PUBLISH}
        </Button>
        <Button
          className={selectedMenu === "pen_delete" ? "selectedMenu" : ""}
          onClick={() => handleState("pen_delete")}
        >
          {MenuTab.PENDING_DELETION}
        </Button>
        <Button
          style={{
            borderBottomRightRadius: "10px",
            borderTopRightRadius: "10px",
          }}
          className={selectedMenu === "delete" ? "selectedMenu" : ""}
          onClick={() => handleState("delete")}
        >
          {MenuTab.DELETED}
        </Button>
      </ButtonGroup>
    </Grid>
  );
}

export default Menus;
